/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-floating-promises */
import { ReloadOutlined } from "@ant-design/icons";
import { Button, PageHeader, Spin } from "antd";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useWebSocket from "react-use-websocket";
import { type WebSocketHook } from "react-use-websocket/dist/lib/types";
import { StatusTag } from "../components/StatusTag";
import { useAppDispatch, useAppSelector } from "../hooks/hooks";
import { type UserType } from "../redux/slices/manageUsers/manageUsersTypes";
import {
  fullInstanceAsync,
  restartAsync,
  selectFullMidservice,
  selectLoading,
  setLoading,
  websocketUpdates,
} from "../redux/slices/midservice/midserviceSlice";
import {
  selectCanUserEdit,
  selectCurrentUser,
} from "../redux/slices/user/userSlice";
import { KKMPage } from "./KKMPage";
import { MidservicePage } from "./MidservicePage/MidservicePage";
import { getApiUrlWS } from "../utils/url";

const SingleInstancePageWebsocket = (): JSX.Element => {
  const fullInstance = useAppSelector(selectFullMidservice);
  const dispatch = useAppDispatch();
  const user: UserType = useAppSelector(selectCurrentUser);
  const canUserEdit = useAppSelector(selectCanUserEdit);

  const { lastMessage }: WebSocketHook<MessageEvent<string>> = useWebSocket(
    `${getApiUrlWS()}/api/v1/ws/updates?device_id=${String(
      fullInstance?.midserviceInstance?.deviceId,
    )}&domain=${String(fullInstance?.midserviceInstance?.domain)}&user_id=${
      user.id
    }`,
    {
      shouldReconnect: (closeEvent) => true,
      reconnectAttempts: 5,
      reconnectInterval: 3,
    },
  );

  useEffect(() => {
    if (lastMessage != null) {
      console.log("Instance status recieved", lastMessage.data);
      dispatch(websocketUpdates(JSON.parse(lastMessage.data)));
      // message.info("Статус инстанса обновлен")
    }
    // dispatch(changeOnlineStatus(JSON.parse(lastMessage.data)))
  }, [lastMessage]);

  const restartInstance = (): void => {
    console.log("onclick restartInstance");
    if (fullInstance?.midserviceInstance?.deviceId != null)
      dispatch(
        restartAsync({
          domain: fullInstance?.midserviceInstance?.domain,
          deviceId: fullInstance?.midserviceInstance?.deviceId,
        }),
      );
  };

  return (
    <>
      {fullInstance?.midserviceInstance != null ? (
        <>
          <PageHeader
            style={{
              padding: 0,
              marginBottom: "1.25rem",
              borderBottom: "1px solid #d9d9d9",
            }}
            className="site-page-header"
            onBack={() => {
              window.history.back();
            }}
            title={fullInstance.midserviceInstance?.deviceId}
            subTitle={
              <StatusTag status={fullInstance.midserviceInstance?.online} />
            }
            extra={
              fullInstance.midserviceInstance.instanceType === "MIDSERVICE" ? (
                <Button
                  icon={<ReloadOutlined />}
                  onClick={restartInstance}
                  key={"restartButton"}
                  disabled={!canUserEdit}
                >
                  Рестарт инстанса
                </Button>
              ) : (
                <></>
              )
            }
          />
          {fullInstance.midserviceInstance.instanceType === "MIDSERVICE" ? (
            <MidservicePage />
          ) : (
            <KKMPage />
          )}
        </>
      ) : (
        <></>
      )}
    </>
  );
};

const SingleInstancePage = (): JSX.Element => {
  console.log("instanceId", "SingleInstancePage");
  const fullInstance = useAppSelector(selectFullMidservice);
  const loading = useAppSelector(selectLoading);
  const params = useParams();
  const dispatch = useAppDispatch();

  useEffect(() => {
    console.log("instanceId params", params);
    dispatch(setLoading(true));
    if (params?.instanceId != null) {
      console.log("instanceId", params.instanceId);
      dispatch(fullInstanceAsync(parseInt(params.instanceId)));
    }
  }, [params?.instanceId]);

  return (
    <Spin spinning={loading}>
      {fullInstance?.midserviceInstance?.deviceId != null ? (
        <SingleInstancePageWebsocket />
      ) : (
        <></>
      )}
    </Spin>
  );
};

// const SingleInstancePageMemo = () => {
//     return useMemo(() => <SingleInstancePage/>, [])
// }

export default React.memo(SingleInstancePage);
